import { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton, { ActionButton1 } from "../utils/ActionButton";
import "../styles/UtahAtAGlance.css";
import "../hexagon.css";
import "../styles/HexGrid.css";
import "../App.css";
import "../styles/UtahVerticals.css";

const auto = "/img/auto.webp";

const leftPanel = [

  {
    label: "Governor’s Corner",
    title: "Governor’s Corner",
    text: "A direct look at the Governor’s initiatives, vision, and statewide priorities shaping Utah’s future.",
    imagepath: "/img/glance-webp/utah_governor_img.webp",
    url: "/utah-at-a-glance/utah-governor"

  },



  {
    label: "What's New",
    title: "What's New",
    text: "Explore the latest updates and new features across UtahData.org at a glance.",
    imagepath: "/img/landing-webp/whats-new-banner.webp",
    url: "/utah-at-a-glance/whats-new",
  },
  {
    label: "Adventure Activities",
    title: "Utah Adventure Activities",
    text: "Utah offers thrilling adventure sports like rock climbing, mountain biking, rafting, and skiing...",
    imagepath: "/img/glance-webp/activities.png",
    url: "/utah-at-a-glance/adventure-activities",
  },
  {
    label: "Air Quality Index",
    title: "Utah Air Quality Index",
    text: "Utah’s air quality fluctuates seasonally, with inversions and wildfires impacting pollution levels...",
    imagepath: "/img/glance-webp/traveller-with-beanie-relaxing-outdoors.webp",
    url: "/utah-at-a-glance/air-quality-index",
  },
  {
    label: "Airports",
    title: "Utah Airports",
    text: "Utah’s airports, led by Salt Lake City International, provide vital air connectivity across the state...",
    imagepath: "/img/glance-webp/airport.webp",
    url: "/utah-at-a-glance/utah-airports ",
  },
  {
    logo: auto,
    label: "Autism and DD",
    title: "Autism and DD",
    text: "Autism and Developmental Disablities-STATISTICS powered by URADD",
    imagepath: "/img/glance-webp/auto1.webp",
    url: "/utah-at-a-glance/autism-dd",
  },
  {
    label: "Budget",
    title: "Budget",
    text: "Explore Utah's budget overview: revenues, expenditures, and priorities across the state.",
    imagepath: "/img/glance-webp/utah-budget.webp",
    url: "/utah-at-a-glance/utah-budget",
  },
  {
    label: "Construction Intelligence",
    title: "Construction Intelligence",
    text: "Explore comprehensive construction metrics, workforce trends, and major projects in Utah's booming construction sector.",
    imagepath: "/img/landing-webp/cons.webp",
    url: "/utah-at-a-glance/construction-intelligence",
  },
  {
    label: "Charging Stations",
    title: "Utah Charging Stations",
    text: "Utah is building a strong EV charging network, with fast chargers and public stations expanding across cities...",
    imagepath: "/img/glance-webp/charging-station.webp",
    url: "/utah-at-a-glance/charging-stations",
  },
  {
    label: "Cities",
    title: "Utah Cities",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/cities.webp",
    url: "/utah-at-a-glance/utah-cities",
  },
  {
    label: "Counties",
    title: "Utah Counties",
    text: "Utah has 29 diverse counties ranging from urban Salt Lake County to rural San Juan County, each offering unique landscapes...",
    imagepath: "/img/glance-webp/geoandinsights.webp",
    url: "/utah-at-a-glance/utah-counties",
  },
  {
    label: "Demographics",
    title: "Demographics",
    text: "Understand who lives in Utah—age groups, ethnicity, education, income, and population trends.",
    imagepath: "/img/glance-webp/demographics.png",
    url: "/utah-at-a-glance/demographics ",
  },
 
  {
    label: "Employment",
    title: "Employment in Utah",
    text: "Track Utah’s job sectors, workforce trends, income levels, and economic output.",
    imagepath: "/img/glance-webp/jobs.webp",
    url: "/utah-at-a-glance/utah-employment ",
  },
  {
    label: "In-Demand Jobs & Wages",
    title: "In-Demand Jobs and Wages",
    text: "Explore Utah's in-demand jobs and wages, highlighting high-growth industries and competitive salaries across the state.",
    imagepath: "/img/landing-webp/InDemandJobsWages.webp",
    url: "/utah-at-a-glance/in-demand-jobs-and-wages",
  },
  {
    label: "Federal Agencies",
    title: "Utah Federal Agencies",
    text: "Utah is home to various federal departments and agencies that support public services, defense, land management...",
    imagepath: "/img/glance-webp/new-york-city-ellis-island-great-hall.webp",
    url: "/utah-at-a-glance/federal-agencies",
  },
  {
    label: "Financial Institutions",
    title: "Financial Institutions",
    text: "Review personal finance trends, average incomes, economic stability, and financial health.",
    imagepath: "/img/glance-webp/finance3.webp",
    url: "/utah-at-a-glance/financial-institutions",
  },
  {
    label: "Geothermal Hotspots",
    title: "Utah Geothermal Hotspots",
    text: "Utah is rich in geothermal hotspots—particularly along the I‑15 corridor and in southwestern counties like Beaver...",
    imagepath: "/img/glance-webp/geo.webp",
    url: "/utah-at-a-glance/utah-geothermal-hotspots",
  },

  {
    label: "Hill Airforce Base",
    title: "Utah Hill Airforce Base",
    text: "Hill Air Force Base in Utah is a major U.S. Air Force installation known for its critical role in aircraft maintenance...",
    imagepath: "/img/glance-webp/f-16.avif",
    url: "/utah-at-a-glance/hill-airforce-base",
  },

  {
    label: "Hospitals",
    title: "Utah Hospitals",
    text: "Utah hospitals provide high-quality medical care across the state, serving both urban and rural communities with advanced...",
    imagepath: "/img/glance-webp/hospital1.webp",
    url: "/utah-at-a-glance/hospitals",
  },
  {
    label: "Housing",
    title: "Housing in Utah",
    text: "Utah's housing market reflects rapid growth and high demand, driven by population increases, economic expansion, and a strong...",
    imagepath: "/img/glance-webp/housing.webp",
    url: "/utah-at-a-glance/utah-housing",
  },
    {
    label: "KCG Sandbox",
    title: "KCG Sandbox",
    text: "Research-grade KPIs turned into a clean, drillable web experience built directly from the 2026 Economic Report to the Governor.",
    imagepath: "/img/landing-webp/KEMC.webp",
    url: "/kcg-sandbox",
  },
  {
    label: "Libraries",
    title: "Utah Libraries",
    text: "Utah boasts a robust network of libraries",
    imagepath: "/img/glance-webp/interior.webp",
    url: "/utah-at-a-glance/utah-libraries",
  },
  {
    label: "MLM",
    title: "Utah MLM",
    text: "Utah is a major hub for multi-level marketing (MLM), home to several prominent MLM companies and a strong direct sales culture.",
    imagepath: "/img/glance-webp/mlm.webp",
    url: "/utah-at-a-glance/mlm",
  },
  {
    label: "Mines",
    title: "Utah Mines",
    text: "Uncover the industrial heart of Utah with a detailed look at its major mines",
    imagepath: "/img/glance-webp/mines.webp",
    url: "/utah-at-a-glance/utah-mines",
  },
  {
    label: "NonProfits",
    title: "Nonprofits",
    text: "Utah is home to numerous non-profit organizations dedicated to serving communities, protecting the environment, supporting vulnerable populations, and enhancing quality of life across the state.",
    imagepath: "/img/glance-webp/nonprofits.webp",
    url: "/utah-at-a-glance/utah-nonprofits",
  },
  {
    label: "Nonprofit Data Insights",
    title: "Utah Nonprofit Data Insights",
    text: "Explore Utah's nonprofit sector with data-driven insights on organizations, impact, and community engagement across the state.",
    imagepath: "/img/landing/service.webp",
    url: "/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights",
  },
  {
    label: "Operation Gigawatt",
    title: "Utah Operation Gigawatt",
    text: "Explore Utah's Operation Gigawatt initiative focused on energy growth, infrastructure readiness, and long-term statewide capacity planning.",
    imagepath: "/img/glance-webp/powergrid.webp",
    url: "/utah-at-a-glance/utah-operation-gigawatt",
  },
  // {
  //   label: "NonProfits",
  //   title: "Nonprofits",
  //   text: "Utah is home to numerous non-profit organizations dedicated to serving communities, protecting the environment, supporting vulnerable populations, and enhancing quality of life across the state.",
  //   imagepath: "/img/glance-webp/nonprofits.webp",
  //   url: "/utah-at-a-glance/utah-nonprofits",
  // },
  {
    label: "Places to Visit",
    title: "Utah Places to Visit",
    text: "Utah offers breathtaking destinations such as Zion National Park, Bryce Canyon, Arches, Monument Valley, and Salt Lake City...",
    imagepath: "/img/glance-webp/stone-gate-bryce-canyon-national-park.webp",
    url: "/utah-at-a-glance/utah-places-to-visit",
  },
  {
    label: "Research Centers and Institutes",
    title: "Utah Research Centers and Institutes",
    text: "Research Centers and Institutes: Advancing Innovation Across Utah",
    imagepath: "/img/glance-webp/research.webp",
    url: "/utah-at-a-glance/research-centers-and-institutes",
  },
  {
    label: "Sports Club",
    title: "Utah Sports Club",
    text: "Highlighting major and minor league teams, college athletics, and community sports programs.",
    imagepath: "/img/glance-webp/sports.webp",
    url: "/utah-at-a-glance/sports-club",
  },
  {
    label: "Taxes",
    title: "Taxes",
    text: "Understand how Utah ranks in taxation, incentives, and economic competitiveness.",
    imagepath: "/img/glance-webp/taxes.webp",
    url: "/utah-at-a-glance/taxes ",
  },
  {
    label: "Universities and Schools",
    title: "Universities and Schools",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/eduandresource.webp",
    url: "/utah-at-a-glance/universities-and-schools",
  },
  {
    label: "Utah Schools",
    title: "Utah Schools",
    text: "Explore Utah's education landscape, from K-12 districts to higher education institutions, and understand how Utah is shaping the future of learning.",
    imagepath: "/img/landing-webp/utahschools.webp",
    url: "/utah-at-a-glance/universities-and-schools/utah-schools",
  },
   {
    label: "Utah History",
    title: "Utah History",
    text: "Explore Utah's rich history, from indigenous cultures and pioneer settlements to modern developments, shaping the state's unique identity and heritage.",
    imagepath: "/img/landing-webp/UTDT-history.webp",
    url: "/utah-at-a-glance/utah-history",
  },
  {
    label: "Utah Land Ownership",
    title: "Utah Land Ownership Distribution",
    text: "Explore the distribution of land ownership in Utah, including federal, state, private, and tribal lands, and understand how these categories shape the state's landscape and resource management.",
    imagepath: "/img/landing-webp/utahfaqbg.jpg",
    url: "/utah-at-a-glance/utah-land",
  },

    {
    label: "Utah Legislature",
    title: "Utah Legislature",
    text: "Explore the Utah Legislature's structure, members, and legislative process, providing insights into how laws are made in the Beehive State.",
    imagepath: "/img/landing-webp/Utah-legislature.webp",
    url: "/utah-at-a-glance/utah-legislature",
  },
  {
    label: "Unemployment Rate",
    title: "Utah Unemployment Rate",
    text: "Utah maintains one of the lowest unemployment rates in the nation, reflecting a resilient and stable economy.",
    imagepath: "/img/glance-webp/unemployment1.webp",
    url: "/utah-at-a-glance/unemployment-rate",
  },
  {
    label: "Voters Count",
    title: "Voters Count of Utah",
    text: "Engage with statistics on voting participation, registration, and electoral history.",
    imagepath: "/img/glance-webp/voterscount.webp",
    url: "/utah-at-a-glance/utah-voters-count",
  },

  {
    label: "Zip Codes",
    title: "Utah Zip Codes",
    text: " Utah ZIP codes organize the state's regions for efficient mail delivery and reflect geographic...",
    imagepath: "/img/glance-webp/close-up-magnifying-glass-map.webp",
    url: "/utah-at-a-glance/zipcodes",
  },
    {
    label: "Who Uses UtahData",
    title: "Who Uses UtahData",
    text: "See what kinds of data UtahData offers and who can use it, from policymakers and economists to educators, businesses, and tourists.",
    imagepath: "/img/landing-webp/who-uses-utahdata-hero.svg",
    url: "/utah-at-a-glance/who-uses-utahdata",
  },
];

const generateHexRows = () => {
  const width = window.innerWidth;
  const rows = [];

  if (width <= 600) {
    // 🔹 Mobile: alternate 3 and 2 items per row
    for (let i = 0, toggle = true; i < leftPanel.length;) {
      const count = toggle ? 3 : 2;
      rows.push(leftPanel.slice(i, i + count));
      i += count;
      toggle = !toggle;
    }
  } else if (width > 600 && width < 1030) {
    // 🔹 Tablet: 5 items per row
    for (let i = 0; i < leftPanel.length; i += 5) {
      rows.push(leftPanel.slice(i, i + 5));
    }
  } else {
    // 🔹 Desktop: 7 items per row
    for (let i = 0; i < leftPanel.length; i += 7) {
      rows.push(leftPanel.slice(i, i + 7));
    }
  }

  return rows;
};

const hexRows = generateHexRows();

const UtahAtAGlance = () => {
  const [selectedTitle, setSelectedTitle] = useState(null);
  const filteredCards = selectedTitle
    ? leftPanel.filter((item) => item.title === selectedTitle)
    : leftPanel;
  const [activeTab, setActiveTab] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div>
      <LandingSection
        data={{ imageName: "login.webp", title: "Utah At a Glance" }}
      />
      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2>
              One State. Many Stories. Dive into the data that defines Utah.
            </h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
            <p>
              Explore the heart of Utah its people, places, economy, and
              culture. From county level insights to infrastructure and
              lifestyle, this is your one stop overview of what defines the
              Beehive State.
            </p>
          </div>
        </div>
      </div>

      <div className="">
        <ul id="hexGrid">
          {leftPanel.slice(0, 9).map((btn, idx) => (
            <li className="hex" key={idx}>
              <div className="hexIn">
                <a 
                  className="hexLink" 
                  href={btn.url || "#"}
                  onClick={(e) => {
                    if (!btn.url) {
                      e.preventDefault();
                      setShowPopup(true);
                    }
                  }}
                  title={!btn.url ? "Coming Soon" : ""}
                >
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo2">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="">
        <ul id="hexGrid">
          {leftPanel.slice(9, 18).map((btn, idx) => (
            <li className="hex" key={idx}>
              <div className="hexIn">
                <a 
                  className="hexLink" 
                  href={btn.url || "#"}
                  onClick={(e) => {
                    if (!btn.url) {
                      e.preventDefault();
                      setShowPopup(true);
                    }
                  }}
                  title={!btn.url ? "Coming Soon" : ""}
                >
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo2">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="">
        <ul id="hexGrid" className="hexGrid-last-row">
          {leftPanel.slice(18, leftPanel.length).map((btn, idx) => (
            <li className="hex" key={idx}>
              <div className="hexIn">
                <a 
                  className="hexLink" 
                  href={btn.url || "#"}
                  onClick={(e) => {
                    if (!btn.url) {
                      e.preventDefault();
                      setShowPopup(true);
                    }
                  }}
                  title={!btn.url ? "Coming Soon" : ""}
                >
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo2">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* <div className="">
        <ul id="hexGrid" className="hexGrid-last-row">
          {leftPanel.slice(-2).map((btn, idx) => (
            <li className="hex hex-last-center" key={idx}>
              <div className="hexIn">
                <a className="hexLink" href={btn.url || "#"}>
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo2">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div> */}

      <section className="why-section ">
        <div className="fit-text-container">
          <h1 className="background-title">SHAPING TOMORROW, TOGETHER</h1>
        </div>

        <h2 className="section-heading">What's Next for Utah?</h2>

        <p className="section-description">
          Utah is moving forward with bold ideas smart cities, clean energy, and
          inclusive growth powered by data. If you're passionate about shaping
          the future or want to collaborate, reach out to us and be part of the
          journey. Let’s build a stronger, smarter Utah together.
        </p>
        <div style={{ margin: "40px 0" }}>
          <ActionButton data="Contact Us" link="/contact-us" />
        </div>
      </section>

      {showPopup && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] p-4 backdrop-blur-sm" onClick={() => setShowPopup(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center shadow-2xl transform transition-all" onClick={e => e.stopPropagation()}>
            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4 border border-blue-100">
              <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Coming Soon</h3>
            <p className="text-gray-600 mb-6">We're currently gathering data and building this dashboard. Please check back soon!</p>
            <div className="flex justify-center w-full mt-4">
              <ActionButton1 data="Got It" onClick={() => setShowPopup(false)} />
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default UtahAtAGlance;
